import { render, staticRenderFns } from "./UBC_2025_CalorimetryLab_Results.vue?vue&type=template&id=3789bb62&scoped=true&"
import script from "./UBC_2025_CalorimetryLab_Results.vue?vue&type=script&lang=js&"
export * from "./UBC_2025_CalorimetryLab_Results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3789bb62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
